<div class="body-details p-3" *ngIf="lmService.is_menu_hide" style="border-radius: 0px">
  <app-menu class="p-0" [isSetting]="true" [margin]="isLeftPaneExpanded == true ? '375px' : '0px'"></app-menu>
</div>
<div class="flex_center {{ isRightBarView ? 'flex_center_extended' : '' }}" [style.top.px]="lmService.selected_workflow?._id ? 0 : ''">
  <div class="wid_" [ngStyle]="{ zoom: zoom_ }">
    <div class="tree" appMovable>
      <ul>
        <div *ngTemplateOutlet="recursiveMenu; context: { $implicit: flowStackCall }"></div>
        <ng-template #recursiveMenu let-conditions let-i="index">
          <li class="{{ flowStackCall?.[0]?.is_readonly ? 'specified-status-space' : '' }}" *ngFor="let condition of conditions; let counter = index">
            <div
              class="wrr  {{ condition?.class }}"
              [ngClass]="{
                is_active: condition?.isAction === true && condition?.class === 'active',
                is_active1: condition?.isAction === null && condition?.class === 'active',
                is_active2: condition?.isAction === false && condition?.class === 'active',
              }"
              [ngStyle]="{
                border: condition?.isAction ? '1px solid #3CB043' : condition?.isAction === null ? '1px solid #3c99d4' : '1px solid #FCAE1E',
              }">
              <i
                class="pi pi-plus f-14 text-primary mr-1"
                (click)="getParentId(condition, condition.id, true)"
                [ngStyle]="{ color: '#1a2f45' }"
                [ngClass]="{
                  plus: !condition?.is_submodule && condition.trigger_id === '1',
                  pen: condition.trigger_id !== '1' || (condition?.is_submodule && condition.trigger_id == '1'),
                }"></i>
              <i
                class="pi pi-times f-14 plus"
                *ngIf="(condition?.trigger_id == '1' && condition?.is_submodule) || condition?.trigger_id !== '1'"
                (click)="removeItem(flowStackCall, condition.id)"></i>

              <i
                class="pi pi-plus p_en"
                (click)="getParentId(condition, condition.id, false)"
                *ngIf="condition?.children && condition?.children.length > 0"></i>

              <span (click)="addNewItemSubLevelView(condition)" id="{{ condition.id }}"></span>
              <div class="box_ mb-1" (click)="activeFlow(condition)">
                <div class="icon" [ngStyle]="{ color: condition?.isAction ? '#3CB043' : condition?.isAction === null ? '#3c99d4' : '#FCAE1E' }">
                  <!-- <span class="pi {{ condition?.icon ? condition?.icon : 'pi-plus invisible' }}"></span> -->
                  <span [ngClass]="getIconClass(condition?.icon)"></span>
                </div>
                <div class="overflow-hidden">
                  <p class="title_ text-ellipsis">{{ condition?.tigger_title }}</p>
                  <p class="title_ text-ellipsis mt-1 f-10">{{ _workflowService.module_mapping[condition?.module] }}</p>
                  <ng-container *ngIf="flowStackCall?.[0]?.is_readonly">
                    <p class="sample status-progress" *ngIf="condition && condition?.already_true && condition.is_condition_true">
                      <img [src]="images?.progress_once_icon" />
                    </p>
                    <p
                      class="sample status-progress"
                      [escape]="false"
                      tooltipStyleClass="automation-trigger"
                      [pTooltip]="getFolderFileInformationTooltipHandler(condition)"
                      tooltipPosition="right"
                      *ngIf="
                        condition && !condition?.already_true && (condition.is_condition_true || condition.is_readonly || condition.is_child_trigger)
                      ">
                      <img [src]="common_images?.progress_completed_icon" />
                    </p>
                    <p
                      class="sample status-progress"
                      [escape]="false"
                      tooltipStyleClass="automation-trigger"
                      [pTooltip]="getFolderFileInformationTooltipHandler(condition)"
                      tooltipPosition="right"
                      *ngIf="condition && !condition?.already_true && condition.is_condition_true === false">
                      <img [src]="images?.progress_uncompleted_icon" />
                    </p>
                  </ng-container>
                </div>
              </div>
              <hr class="m-0 custom-breaker" />
              <p class="sample">
                <ng-container *ngIf="condition?.trigger_id === '107'">
                  <div class="cursor-pointer" *ngIf="condition?.field_child?.length > 0" (click)="is_field_con = !is_field_con">
                    <ng-container *ngIf="is_field_con; else moreCon">
                      <ng-container *ngFor="let con of condition?.field_child?.slice(0, 1); let i = index">
                        <div class="d-flex align-items-center">
                          <p class="w-33 text-captilize">{{ con?.left_value }}</p>
                          <p class="sep-dot"></p>
                          <p class="w-25 text-captilize">{{ con?.equality_value }}</p>
                          <p class="sep-dot"></p>
                          <p class="text-captilize">{{ con?.agent_name ? con?.agent_name : con?.rightoperator }}</p>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #moreCon>
                      <ng-container *ngFor="let con of condition?.field_child; let i = index">
                        <div class="d-flex align-items-center">
                          <p class="w-33 text-captilize">{{ con?.left_value }}</p>
                          <p class="sep-dot"></p>
                          <p class="w-25 text-captilize">{{ con?.equality_value }}</p>
                          <p class="sep-dot"></p>
                          <p class="text-captilize">{{ con?.agent_name ? con?.agent_name : con?.rightoperator }}</p>
                        </div>
                        <!-- <span [ngClass]="{'mt-1': true}">{{con.leftoperator+' - '+con.equality+' - '+con.rightoperator}}</span><br> -->
                      </ng-container>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngIf="condition?.trigger_id === '202'; else no_email">
                  <p>{{ condition?.email?.subject }}</p>
                  <p
                    [innerHTML]="is_email_message ? (condition?.email?.message | slice: 0 : 70) : condition?.email?.message"
                    (click)="is_email_message = !is_email_message"
                    class="mt-1 cursor-pointer custom-ul-margin"></p>
                </ng-container>
                <ng-template #no_email>
                  {{ getDescription(condition) }}
                </ng-template>
              </p>
            </div>
            <ul *ngIf="condition?.children">
              <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: condition?.children }"> </ng-container>
            </ul>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
</div>
<!-- Side menu icons -->
<ng-container *ngIf="flowStackCall && flowStackCall.length > 0 && !flowStackCall[0].is_readonly">
  <div class="active-flow-action">
    <div class="menu-action-active-flow" (click)="updateHandler()">
      <img [src]="images?.save_icon" />
    </div>
    <div
      class="menu-action-active-flow"
      (click)="toggleProcessPane = !toggleProcessPane; parent_id = con_id = null; toggleProcessPaneObservable.next(toggleProcessPane)">
      <img [src]="images?.network_tree_icon" />
    </div>
    <div class="menu-action-active-flow" (click)="zoom_ = zoom_ - 0.1">
      <img [src]="images?.zoom_out_icon" />
    </div>
    <div class="menu-action-active-flow" (click)="zoom_ = zoom_ + 0.1">
      <img [src]="images?.zoom_in_icon" />
    </div>
    <div class="menu-action-active-flow" (click)="zoom_ = 1">
      <img [src]="images?.reset_icon" />
    </div>
  </div>
</ng-container>

<!-- left-flow -->
<app-left-flow
  class="{{ isRightBarView ? 'invisible' : '' }}"
  (triggerEmitter)="getTrigger($event)"
  (LeftPanelExpanded)="LeftPanelExpandedStatus($event)"></app-left-flow>

<!-- Right Flow -->
<div [class]="isRightBarView ? 'sideBarRightModule__ resizable' : 'sideBar__ resizable'" *ngIf="parent_id || con_id" resizable>
  <div class="grabber" grabber>
    <i class="pi pi-chevron-left f-12"></i>
  </div>

  <div [class]="isRightBarView ? 'scrollRightModule_' : 'scroll_'">
    <div class="d-flex justify-content-between align-items-center">
      <ng-container *ngIf="con_id">
        <div class="mt-1" *ngIf="con_id === '1'">
          <div class="d-flex align-items-center justify-content-between">
            <p class="show-icon f-18">Trigger</p>
          </div>
        </div>
        <div class="mt-1" *ngIf="con_id !== '1'">
          <div class="d-flex align-items-center justify-content-between">
            <p class="show-icon f-18">{{ flow_data.isAction ? 'Action' : 'Condition' }} - {{ GetFieldName(con_id) }}</p>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="parent_id">
        <div class="mt-1">
          <div class="d-flex align-items-center justify-content-between">
            <p class="show-icon f-18">Automations</p>
          </div>
        </div>
      </ng-container>
      <div class="btnCloseFlow">
        <i class="fa fa-times f-18" aria-hidden="true" (click)="parent_id = con_id = null"></i>
      </div>
    </div>

    <!-- Main Add-->
    <ng-container *ngIf="parent_id">
      <flow-trigger (UpdateTriggerList)="getActionStatus($event)"> </flow-trigger>
    </ng-container>

    <ng-container *ngIf="con_id">
      <!-- Titles -->
      <ng-container>
        <div class="bdr_ mb-2"></div>
        <div class="mb-3 mt-2" *ngIf="con_id === '101' || con_id === '103'">
          <p class="show-icon f-12" *ngIf="con_id === '101'">
            {{
              flowStackCall[0]?.module === 'lead_management' ? 'Lead' : (_workflowService.GetAlteredModuleName(flowStackCall[0]?.module) | titlecase)
            }}
            created
          </p>
          <p class="show-icon f-12" *ngIf="con_id === '103'">
            {{
              flowStackCall[0]?.module === 'lead_management' ? 'Lead' : (_workflowService.GetAlteredModuleName(flowStackCall[0]?.module) | titlecase)
            }}
            deleted
          </p>
        </div>
      </ng-container>

      <!-- Conditions -->
      <ng-container>
        <div class="form-group mb-3" *ngIf="con_id === '107'">
          <div class="advanceView js-treeview">
            <div class="mb-2">
              <div *ngTemplateOutlet="commonConditionSaveLoad"></div>
            </div>
            <ul class="p-0 mt-3">
              <div *ngTemplateOutlet="recursiveInputField; context: { $implicit: condition_input }"></div>
            </ul>
            <div class=""></div>
          </div>
        </div>
        <div class="form-group mb-3 bdr" *ngIf="con_id === '102'">
          <label>Select field</label>
          <ng-select
            [items]="entityField"
            bindLabel="label"
            bindValue="name"
            [searchable]="true"
            placeholder="Select Field"
            [multiple]="true"
            [(ngModel)]="flow_data.update_id"
            class="ng-site-input w-76 mb-1 trigger-Name min-height-select"
            name="user_id">
          </ng-select>
        </div>

        <div class="form-group mb-3 d-flex flex-column" *ngIf="con_id === '104'">
          <label>Select the condition date</label>
          <div class="date-bordered mt-1">
            <p-calendar
              [showButtonBar]="true"
              [(ngModel)]="flow_data.date"
              class="conditionDue"
              [ngModelOptions]="{ standalone: true }"
              [maxDateCount]="1"
              selectionMode="single"
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              [firstDayOfWeek]="1"
              placeholder="Date Ranges"
              (onClearClick)="clearSearch()"
              [showTime]="true">
            </p-calendar>
          </div>
        </div>

        <ng-container *ngIf="con_id === '105'">
          <div class="form-group mb-3 d-flex flex-column date-range">
            <label>Enter days</label>
            <input
              type="number"
              placeholder="Days"
              pattern="[0-9]"
              step="1"
              onkeypress="return !(event.charCode == 46)"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              [min]="0"
              [max]="1000"
              inputId="days-gap"
              name="days_gap"
              [(ngModel)]="flow_data.time.days"
              class="trigger-Name" />
          </div>
          <div class="form-group mb-3 d-flex flex-column date-range">
            <label>Enter hours</label>
            <input
              type="number"
              placeholder="Hours"
              pattern="[0-9]"
              step="1"
              onkeypress="return !(event.charCode == 46)"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              [min]="0"
              [max]="100"
              inputId="rightoperator"
              name="hours"
              [(ngModel)]="flow_data.time.hours"
              class="trigger-Name" />
          </div>
          <div class="form-group mb-3 d-flex flex-column date-range">
            <label>Enter minutes</label>
            <input
              type="number"
              placeholder="Minutes"
              pattern="[0-9]"
              step="1"
              onkeypress="return !(event.charCode == 46)"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              [min]="0"
              [max]="100"
              inputId="minutes"
              name="minutes"
              [(ngModel)]="flow_data.time.minutes"
              class="trigger-Name" />
          </div>
          <div class="form-group mb-3 d-flex flex-column date-range">
            <label>Send Limit – E.g. +2 = send 2 times. Leave blank for unlimited</label>
            <input
              type="number"
              placeholder="event occurrence"
              pattern="[0-9]"
              step="1"
              onkeypress="return !(event.charCode == 46)"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              [min]="0"
              [max]="100"
              inputId="occurrence"
              name="loop"
              [(ngModel)]="flow_data.time.loop"
              class="trigger-Name" />
          </div>
          <div class="form-group mb-3 d-flex flex-column date-range">
            <label>Stop Reminders When – Select field to stop when updated</label>
            <ng-select
              [items]="entityField"
              bindLabel="label"
              bindValue="name"
              [searchable]="true"
              placeholder="Select Field"
              [multiple]="false"
              [(ngModel)]="flow_data.time.watch_field"
              class="ng-site-input w-76 mb-1 trigger-Name min-height-select"
              name="user_id">
            </ng-select>
          </div>
        </ng-container>

        <div class="form-group mb-3 bdr" *ngIf="con_id === '106'">
          <label>Select a user in your office.</label>
          <div class="form-group">
            <ng-select
              [items]="UserRoles"
              bindLabel="full_name"
              bindValue="_id"
              [searchable]="true"
              [(ngModel)]="flow_data.user.user_role"
              placeholder="Select user role"
              [multiple]="false"
              class="ng-site-input w-76 mb-1 trigger-Name"
              (change)="onChangeUserRole($event)"
              name="user_role_id"
              id="user_role_id">
            </ng-select>
          </div>
          <ng-select
            [items]="UsersbyRole"
            *ngIf="UsersbyRole?.length > 0"
            bindLabel="full_name"
            bindValue="_id"
            [searchable]="true"
            [(ngModel)]="flow_data.user.user"
            placeholder="Select users"
            [multiple]="false"
            class="ng-site-input w-76 mb-1 trigger-Name"
            name="user_id"
            id="user_id">
          </ng-select>
        </div>

        <div class="form-group mb-3 bdr" *ngIf="con_id === '108'">
          <label>Select field</label>
          <ng-select
            [items]="entityField"
            bindLabel="label"
            bindValue="name"
            [searchable]="true"
            [(ngModel)]="flow_data.validation"
            placeholder="Select Field"
            [multiple]="true"
            class="ng-site-input w-76 mb-1 trigger-Name min-height-select validation"
            name="user_id"
            id="user_id">
          </ng-select>
          <div class="mt-2 d-flex align-items-center" *ngIf="activatedModuleName === 'project_units'">
            <p-checkbox [(ngModel)]="flow_data.eoi_cancelled" [binary]="true"></p-checkbox>
            <p>Unit Active EOIs must be canceled</p>
          </div>
        </div>

        <!-- Advanced Scheduling -->
        <div class="form-group mb-3 bdr" *ngIf="con_id === '109'">
          <label>Select field</label>
          <ng-select
            [items]="entityField"
            bindLabel="label"
            bindValue="name"
            [searchable]="true"
            [(ngModel)]="flow_data.advanced_scheduling.selectedField"
            placeholder="Select Field"
            class="ng-site-input w-76 mb-1 trigger-Name min-height-select"
            name="user_id"
            id="user_id">
          </ng-select>
          <p class="show-icon f-12 mt-2">On</p>
          <div class="d-flex">
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 min-width-50">
              <label>Time</label>
              <input
                type="text"
                placeholder="HH:MM AM/PM"
                inputId="on_time"
                name="on_time"
                class="trigger-Name"
                (change)="onTimeInputChange($event, 'on')"
                [(ngModel)]="flow_data.advanced_scheduling.on.time" />
            </div>
          </div>
          <hr />
          <p class="show-icon f-12 mt-2">Before</p>
          <div class="d-flex">
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 min-width-40">
              <label>Days</label>
              <input
                type="number"
                placeholder="days"
                min="0"
                max="1000"
                inputId="days-gap"
                name="days_gap"
                [(ngModel)]="flow_data.advanced_scheduling.before.days"
                class="trigger-Name" />
            </div>
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 min-width-40">
              <label>Time</label>
              <input
                type="text"
                placeholder="HH:MM AM/PM"
                inputId="before_time"
                name="before_time"
                class="trigger-Name"
                (change)="onTimeInputChange($event, 'before')"
                [(ngModel)]="flow_data.advanced_scheduling.before.time" />
            </div>
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 w-auto">
              <label>&nbsp;</label>
              <span class="d-flex h-100 align-items-center">
                <p-checkbox
                  name="beforeexludeweek"
                  [(ngModel)]="flow_data.advanced_scheduling.before.excludeweek"
                  [value]="flow_data.advanced_scheduling.before.excludeweek"
                  inputId="beforeexludeweek"
                  binary="true">
                </p-checkbox>
                <label class="cursor-pointer f-12 font-weight-normal -mt-1" for="beforeexludeweek">&nbsp;Exclude weekend</label>
              </span>
            </div>
          </div>
          <hr />
          <p class="show-icon f-12 mt-2">After</p>
          <div class="d-flex">
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 min-width-40">
              <label>Days</label>
              <input
                type="number"
                placeholder="days"
                min="0"
                max="1000"
                inputId="days-gap"
                name="days_gap"
                [(ngModel)]="flow_data.advanced_scheduling.after.days"
                class="trigger-Name" />
            </div>
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 min-width-40">
              <label>Time</label>
              <input
                type="text"
                placeholder="HH:MM AM/PM"
                inputId="after_time"
                name="after_time"
                class="trigger-Name"
                (change)="onTimeInputChange($event, 'after')"
                [(ngModel)]="flow_data.advanced_scheduling.after.time" />
            </div>
            <div class="form-group mb-3 d-flex flex-column date-range pr-2 w-auto">
              <label>&nbsp;</label>
              <span class="d-flex h-100 align-items-center">
                <p-checkbox
                  name="afterexludeweek"
                  [(ngModel)]="flow_data.advanced_scheduling.after.excludeweek"
                  [value]="flow_data.advanced_scheduling.after.excludeweek"
                  inputId="afterexludeweek"
                  [binary]="true">
                </p-checkbox>
                <label class="cursor-pointer f-12 font-weight-normal -mt-1" for="afterexludeweek">&nbsp;Exclude weekend</label>
              </span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Actions -->
      <ng-container>
        <!-- Notification Action bar -->
        <div class="row o_" *ngIf="con_id === '201'">
          <div class="col-md-12 form-group mb-2 bdr">
            <small>Notifications are only received if a user has selected to receive web notifications</small>
            <div class="d-flex align-items-center justify-content-between">
              <label for="lastname">Notify User<span title="Required">*</span></label>
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                pTooltip="Add"
                tooltipPosition="top"
                class="p-button-rounded p-button-secondary p-button-text"
                (click)="addOrRemoveFieldNotificationToAction('add')"></button>
            </div>
            <div class="bg-light rounded w-100 position-relative">
              <ng-container *ngFor="let notification of flow_data?.notification?.notification_to">
                <div class="d-flex align-items-center">
                  <div class="treeview__level ml-2">
                    <img
                      [src]="common_images?.delete_icon"
                      class="cursor-pointer"
                      width="18px"
                      class="cursor-pointer"
                      (click)="addOrRemoveFieldNotificationToAction('remove', notification)" />
                  </div>
                  <div class="row m-2 w-100 d-flex align-items-center">
                    <div class="col-md-6 bdr">
                      <ng-select
                        [items]="_workflowService.actionDeliverChannel"
                        bindLabel="label"
                        bindValue="name"
                        [searchable]="true"
                        [(ngModel)]="notification.notify_user"
                        placeholder="Select Users From"
                        [multiple]="false"
                        (change)="notification.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name"
                        name="all_user_receiver_type"
                        id="all_user_receiver_type">
                      </ng-select>
                    </div>
                    <div class="col-md-6 bdr" *ngIf="notification.notify_user == 'association_based'">
                      <ng-select
                        [items]="_workflowService?.association_based"
                        bindLabel="name"
                        bindValue="value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Role"
                        [multiple]="true"
                        [(ngModel)]="notification.association_role"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>
                    <div
                      class="col-md-6"
                      *ngIf="notification.notify_user && onChangeNotifyUserReceiver({ name: notification.notify_user })?.length > 0">
                      <ng-select [(ngModel)]="notification.user" [searchable]="true" placeholder="Select Users To" [multiple]="true">
                        <ng-option *ngFor="let user of onChangeNotifyUserReceiver({ name: notification.notify_user })" [value]="user._id">
                          <div class="mb-1">
                            {{ user?.full_name }}
                          </div>
                          <div class="d-flex align-items-center text-lowercase" *ngIf="user?.email">
                            <i class="pi pi-envelope f-12"></i>&nbsp;{{ user?.email }}
                          </div>
                          <div class="d-flex align-items-center mt-1" *ngIf="user?.mobile_no">
                            <i class="pi pi-phone f-12"></i>&nbsp;{{ user?.mobile_no }}
                          </div>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="col-md-12 form-group mb-2 bdr">
            <label>Notification From<span title="Required">*</span></label>
            <ng-select
              [items]="_workflowService.actionSenderChannel"
              bindLabel="label"
              bindValue="name"
              [searchable]="true"
              placeholder="Select Users"
              [multiple]="false"
              [clearable]="false"
              (change)="onChangeNotifyUserSender($event, flow_data)"
              name="all_user_sender"
              [ngClass]="{ '_input-error': submitted }"
              id="all_user_sender_type"
              [(ngModel)]="flow_data.notification.notify_from">
            </ng-select>
          </div>

          <div class="col-md-12 form-group mb-2 bdr" *ngIf="NotifyUsersSender && NotifyUsersSender.length > 0">
            <ng-select [(ngModel)]="flow_data.notification.sender" [searchable]="true" placeholder="Select Users From" [multiple]="true">
              <ng-option *ngFor="let user of NotifyUsersSender" [value]="user._id">
                <div class="mb-1">
                  {{ user?.full_name }}
                </div>
                <div class="d-flex align-items-center" *ngIf="user?.email"><i class="pi pi-envelope f-12"></i>&nbsp;{{ user?.email }}</div>
                <div class="d-flex align-items-center mt-1" *ngIf="user?.mobile_no"><i class="pi pi-phone f-12"></i>&nbsp;{{ user?.mobile_no }}</div>
              </ng-option>
            </ng-select>
          </div>

          <div class="col-md-12 form-group mb-2">
            <label>Notification Subject<span title="Required">*</span></label>
            <input
              type="text"
              placeholder="Subject"
              inputId="title"
              name="title"
              class="trigger-Name"
              [(ngModel)]="flow_data.notification.subject"
              (focus)="isSubject = true" />
          </div>
          <div class="col-md-12 form-group mb-2 a_b_c" *ngIf="flow_data && flow_data.notification">
            <label>Notification Message<span title="Required">*</span></label>
            <div class="_paragraph content-inputs">
              <ckeditor
                #editorRef
                [(ngModel)]="flow_data.notification.message"
                *ngIf="isItTag"
                [editor]="Editor"
                style="height: 200px"
                (focus)="isSubject = false"
                (ready)="onReady($event, api)">
              </ckeditor>
            </div>
            <div class="_paragraph content-inputs">
              <ckeditor
                #editorRef
                [(ngModel)]="flow_data.notification.message"
                [editor]="Editor"
                *ngIf="!isItTag"
                style="height: 200px"
                (focus)="isSubject = false"
                (ready)="onReady($event, api)">
              </ckeditor>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group mb-2 bdr">
              <label for="">Select Module</label>
              <ng-select
                [items]="_workflowService?.module_array"
                bindLabel="name"
                bindValue="module_value"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select Module"
                [multiple]="false"
                (change)="selectTemplate($event)">
              </ng-select>
            </div>
          </div>

          <div class="col-12" *ngIf="leadFields && leadFields.length > 0">
            <input type="text" placeholder="Search Tag" inputId="title" name="title" class="trigger-Name mb-2" [(ngModel)]="searchStr" />
            <ul class="tags_">
              <ng-container *ngFor="let item of leadFields | filter_pipe: searchStr">
                <li (click)="copyHandler(item.name)" (dblClick)="triggerEmitter(item.name, true)" appDoubleClick>{{ item.label }}</li>
              </ng-container>
            </ul>
          </div>
        </div>

        <!-- Email Action bar -->
        <div class="row o_" *ngIf="con_id === '202'">
          <div class="col-md-12 form-group bdr">
            <div class="d-flex align-items-center justify-content-between">
              <label>Email To</label>
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                pTooltip="Add"
                tooltipPosition="top"
                class="p-button-rounded p-button-secondary p-button-text"
                (click)="addOrRemoveFieldEmailToAction('add')"></button>
            </div>
            <div class="bg-light rounded w-100 position-relative">
              <ng-container *ngFor="let mail of flow_data?.email?.email_to">
                <div class="d-flex align-items-center">
                  <div class="treeview__level ml-2">
                    <img
                      [src]="common_images?.delete_icon"
                      class="cursor-pointer"
                      width="18px"
                      class="cursor-pointer"
                      (click)="addOrRemoveFieldEmailToAction('remove', mail)" />
                  </div>
                  <div class="row m-2 w-100 d-flex align-items-center">
                    <div class="bdr" [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'">
                      <ng-select
                        [items]="_workflowService.actionDeliverChannel"
                        bindLabel="label"
                        bindValue="name"
                        [searchable]="true"
                        [(ngModel)]="mail.to"
                        placeholder="Select Users From"
                        [multiple]="false"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name"
                        name="all_user_receiver_type"
                        id="all_user_receiver_type">
                      </ng-select>
                    </div>
                    <div class="col-md-6 bdr" *ngIf="mail.to == 'association_based'">
                      <ng-select
                        [items]="_workflowService?.association_based"
                        bindLabel="name"
                        bindValue="value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Role"
                        [multiple]="true"
                        [(ngModel)]="mail.association_role"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>
                    <!--selectSubModule($event) on change  -->
                    <div class="col-md-4 bdr" *ngIf="mail.to == 'form'">
                      <ng-select
                        [items]="_workflowService?.module_array"
                        bindLabel="name"
                        bindValue="module_value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Module"
                        [multiple]="false"
                        [(ngModel)]="mail.submodule"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>

                    <div
                      [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'"
                      *ngIf="mail.to && onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)?.length > 0">
                      <ng-select [(ngModel)]="mail.user" [searchable]="true" placeholder="Select Users To" [multiple]="true">
                        <ng-option *ngFor="let user of onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)" [value]="user._id">
                          <div class="mb-1">
                            {{ user?.full_name }}
                          </div>
                          <div class="d-flex align-items-center text-lowercase" *ngIf="user?.email">
                            <i class="pi pi-envelope f-12"></i>&nbsp;{{ user?.email }}
                          </div>
                          <div class="d-flex align-items-center mt-1" *ngIf="user?.mobile_no">
                            <i class="pi pi-phone f-12"></i>&nbsp;{{ user?.mobile_no }}
                          </div>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- CC -->
          <div class="col-md-12 form-group bdr">
            <div class="d-flex align-items-center justify-content-between">
              <label>Email CC</label>
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                pTooltip="Add"
                tooltipPosition="top"
                class="p-button-rounded p-button-secondary p-button-text"
                (click)="addOrRemoveFieldEmailCCAction('add')"></button>
            </div>
            <div class="bg-light rounded w-100 position-relative">
              <ng-container *ngFor="let mail of flow_data?.email?.email_cc">
                <div class="d-flex align-items-center">
                  <div class="treeview__level ml-2">
                    <img
                      [src]="common_images?.delete_icon"
                      class="cursor-pointer"
                      width="18px"
                      class="cursor-pointer"
                      (click)="addOrRemoveFieldEmailCCAction('remove', mail)" />
                  </div>
                  <div class="row m-2 w-100 d-flex align-items-center">
                    <div class="bdr" [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'">
                      <ng-select
                        [items]="_workflowService.actionDeliverChannel"
                        bindLabel="label"
                        bindValue="name"
                        [searchable]="true"
                        [(ngModel)]="mail.to"
                        placeholder="Select Users From"
                        [multiple]="false"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name"
                        name="all_user_receiver_type"
                        id="all_user_receiver_type">
                      </ng-select>
                    </div>

                    <div class="col-md-6 bdr" *ngIf="mail.to == 'association_based'">
                      <ng-select
                        [items]="_workflowService?.association_based"
                        bindLabel="name"
                        bindValue="value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Role"
                        [multiple]="true"
                        [(ngModel)]="mail.association_role"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>
                    <!--selectSubModule($event) on change  -->
                    <div class="col-md-4 bdr" *ngIf="mail.to == 'form'">
                      <ng-select
                        [items]="_workflowService?.module_array"
                        bindLabel="name"
                        bindValue="module_value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Module"
                        [multiple]="false"
                        [(ngModel)]="mail.submodule"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>

                    <div
                      [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'"
                      *ngIf="mail.to && onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)?.length > 0">
                      <ng-select [(ngModel)]="mail.user" [searchable]="true" placeholder="Select Users To" [multiple]="true">
                        <ng-option *ngFor="let user of onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)" [value]="user._id">
                          <div class="mb-1">
                            {{ user?.full_name }}
                          </div>
                          <div class="d-flex align-items-center text-lowercase" *ngIf="user?.email">
                            <i class="pi pi-envelope f-12"></i>&nbsp;{{ user?.email }}
                          </div>
                          <div class="d-flex align-items-center mt-1" *ngIf="user?.mobile_no">
                            <i class="pi pi-phone f-12"></i>&nbsp;{{ user?.mobile_no }}
                          </div>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- BCC -->
          <div class="col-md-12 form-group bdr">
            <div class="d-flex align-items-center justify-content-between">
              <label>Email BCC</label>
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                pTooltip="Add"
                tooltipPosition="top"
                class="p-button-rounded p-button-secondary p-button-text"
                (click)="addOrRemoveFieldEmailBCCAction('add')"></button>
            </div>
            <div class="bg-light rounded w-100 position-relative">
              <ng-container *ngFor="let mail of flow_data?.email?.email_bcc">
                <div class="d-flex align-items-center">
                  <div class="treeview__level ml-2">
                    <img
                      [src]="common_images?.delete_icon"
                      class="cursor-pointer"
                      width="18px"
                      class="cursor-pointer"
                      (click)="addOrRemoveFieldEmailBCCAction('remove', mail)" />
                  </div>
                  <div class="row m-2 w-100 d-flex align-items-center">
                    <div class="bdr" [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'">
                      <ng-select
                        [items]="_workflowService.actionDeliverChannel"
                        bindLabel="label"
                        bindValue="name"
                        [searchable]="true"
                        [(ngModel)]="mail.to"
                        placeholder="Select Users From"
                        [multiple]="false"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name"
                        name="all_user_receiver_type"
                        id="all_user_receiver_type">
                      </ng-select>
                    </div>
                    <div class="col-md-6 bdr" *ngIf="mail.to == 'association_based'">
                      <ng-select
                        [items]="_workflowService?.association_based"
                        bindLabel="name"
                        bindValue="value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Role"
                        [multiple]="true"
                        [(ngModel)]="mail.association_role"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>
                    <div class="col-md-4 bdr" *ngIf="mail.to == 'form'">
                      <ng-select
                        [items]="_workflowService?.module_array"
                        bindLabel="name"
                        bindValue="module_value"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Module"
                        [multiple]="false"
                        [(ngModel)]="mail.submodule"
                        (change)="mail.user = null"
                        class="ng-site-input w-76 mb-1 trigger-Name">
                      </ng-select>
                    </div>

                    <div
                      [ngClass]="mail.to === 'form' ? 'col-md-4' : 'col-md-6'"
                      *ngIf="mail.to && onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)?.length > 0">
                      <ng-select [(ngModel)]="mail.user" [searchable]="true" placeholder="Select Users To" [multiple]="true">
                        <ng-option *ngFor="let user of onChangeNotifyUserReceiver({ name: mail.to }, mail.submodule)" [value]="user._id">
                          <div class="mb-1">
                            {{ user?.full_name }}
                          </div>
                          <div class="d-flex align-items-center text-lowercase" *ngIf="user?.email">
                            <i class="pi pi-envelope f-12"></i>&nbsp;{{ user?.email }}
                          </div>
                          <div class="d-flex align-items-center mt-1" *ngIf="user?.mobile_no">
                            <i class="pi pi-phone f-12"></i>&nbsp;{{ user?.mobile_no }}
                          </div>
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group mb-2 bdr">
              <label for="">Email Templates</label>
              <ng-select
                [items]="emailTemplates"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                [clearable]="false"
                [(ngModel)]="flow_data.email.email_template"
                placeholder="Select an email template"
                [multiple]="false"
                (change)="getTemplateBody($event)">
              </ng-select>
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label>Subject</label>
            <input
              type="text"
              placeholder="Subject"
              inputId="title"
              name="title"
              [(ngModel)]="flow_data.email.subject"
              class="trigger-Name"
              (focus)="isSubject = true" />
          </div>
          <div class="col-md-12 form-group mb-3 a_b_c">
            <div class="mb-2 d-flex align-items-center justify-content-between">
              <label>Message</label>
              <button class="_outline-btn" (click)="addNewLeadEmail(); updateHandler()" *ngIf="flow_data.email.email_template">Save Template</button>
            </div>
            <div class="_paragraph content-inputs">
              <ckeditor
                #editorRef
                [(ngModel)]="flow_data.email.message"
                *ngIf="isItTag"
                [editor]="Editor"
                style="height: 200px"
                (focus)="isSubject = false"
                (ready)="onReady($event, api)">
              </ckeditor>
            </div>
            <div class="_paragraph content-inputs">
              <ckeditor
                #editorRef
                [(ngModel)]="flow_data.email.message"
                *ngIf="!isItTag"
                [editor]="Editor"
                style="height: 200px"
                (focus)="isSubject = false"
                (ready)="onReady($event, api)">
              </ckeditor>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group mb-2 bdr">
              <label for="">Select Module</label>
              <ng-select
                [items]="_workflowService?.module_array"
                bindLabel="name"
                bindValue="module_value"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select Module"
                [multiple]="false"
                (change)="selectTemplate($event)">
              </ng-select>
            </div>
          </div>
          <div class="col-12" *ngIf="leadFields && leadFields.length > 0">
            <div class="form-group mb-2 bdr">
              <label for="">Email Templates</label>
              <ng-select
                [items]="emailTemplates"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                [clearable]="false"
                [(ngModel)]="template"
                placeholder="Select an email template"
                [multiple]="false"
                (change)="getTemplateBody($event)">
                <!-- template -->
              </ng-select>
            </div>
          </div>
          <div class="col-12" *ngIf="leadFields && leadFields.length > 0">
            <input type="text" placeholder="Search Tag" inputId="title" name="title" class="trigger-Name mb-2" [(ngModel)]="searchStr" />
            <ul class="tags_">
              <ng-container *ngFor="let item of leadFields | filter_pipe: searchStr">
                <li (click)="copyHandler(item.name)" (dblClick)="triggerEmitter(item.name, false)" appDoubleClick>{{ item.label }}</li>
              </ng-container>
            </ul>
          </div>
        </div>
        <ng-container *ngIf="con_id === '204'">
          <div class="w-100">
            <div class="col-md-12">
              <div class="form-group mb-2 bdr">
                <ng-select
                  [items]="_workflowService?.module_array"
                  bindLabel="name"
                  bindValue="module_value"
                  [searchable]="true"
                  [clearable]="false"
                  placeholder="Select Module"
                  [multiple]="false"
                  [(ngModel)]="flow_data.submodule"
                  class="ng-site-input w-76 mb-1 trigger-Name"
                  (change)="selectSubModule($event)">
                </ng-select>
              </div>
            </div>
          </div>
          <button class="new-add px-3" (click)="AddorRemoveFieldUpdateAction('add')"><i class="pi pi-plus" style="font-size: small"></i> New</button>
          <div class="bg-light mt-4 rounded w-100 position-relative">
            <ng-container *ngFor="let fields of flow_data.update_action_list">
              <div class="d-flex align-items-center">
                <div class="treeview__level ml-2">
                  <img
                    [src]="common_images?.delete_icon"
                    class="cursor-pointer"
                    width="18px"
                    class="cursor-pointer"
                    (click)="AddorRemoveFieldUpdateAction('remove', fields)" />
                </div>
                <div class="row m-2 w-100 d-flex align-items-center">
                  <div class="col-md-6 bdr">
                    <ng-select
                      [items]="entityField"
                      bindLabel="label"
                      bindValue="name"
                      [searchable]="true"
                      [(ngModel)]="fields.leftoperator"
                      placeholder="Select Field"
                      [multiple]="false"
                      class="ng-site-input w-76 mb-1 trigger-Name"
                      name="user_id"
                      (change)="changeSave($event, fields)"
                      id="user_id">
                    </ng-select>
                  </div>
                  <div class="col-md-6" *ngIf="fields?.format == 'format2'">
                    <input
                      type="number"
                      placeholder=""
                      inputId="rightoperator"
                      name="rightoperator"
                      [(ngModel)]="fields.rightoperator"
                      class="trigger-Name" />
                  </div>
                  <div class="col-md-6 bdr" *ngIf="fields?.format == 'format3'">
                    <ng-select
                      [items]="[
                        { id: true, name: 'Yes' },
                        { id: false, name: 'No' },
                      ]"
                      bindLabel="name"
                      [searchable]="true"
                      bindValue="id"
                      [(ngModel)]="fields.rightoperator"
                      [multiple]="false"
                      class="ng-site-input w-76 mb-1 trigger-Name"
                      name="rightoperator"
                      id="rightoperator">
                    </ng-select>
                  </div>
                  <div class="col-md-6 bdr" *ngIf="fields?.format == 'format5or6'">
                    <ng-select
                      [items]="fields?.statusArray"
                      bindLabel="name"
                      [searchable]="true"
                      [bindValue]="fields.bindfield"
                      [(ngModel)]="fields.rightoperator"
                      placeholder=""
                      [multiple]="false"
                      class="ng-site-input w-76 mb-1 trigger-Name"
                      name="rightoperator"
                      id="rightoperator">
                    </ng-select>
                  </div>
                  <div class="col-md-6" *ngIf="fields?.format == 'format1' || fields?.format == 'format4'">
                    <input
                      type="text"
                      *ngIf="!fields?.isAddressBar"
                      placeholder=""
                      inputId="status_name"
                      name="status_name"
                      [(ngModel)]="fields.rightoperator"
                      class="trigger-Name" />
                    <textarea
                      type="text"
                      *ngIf="fields?.isAddressBar"
                      placeholder="Search address"
                      [(ngModel)]="fields.rightoperator"
                      inputId="status_name"
                      name="status_name"
                      (onAddressChange)="handleAddressChange($event)"
                      google-places-autocomplete
                      [options]="options"
                      class="text-area-style mb-1">
                    </textarea>
                  </div>
                  <div class="col-md-6 d-flex flex-column date-range date-bordered" *ngIf="fields?.format == 'format7'">
                    <div></div>
                    <p-calendar
                      [showButtonBar]="true"
                      [(ngModel)]="fields.rightoperator"
                      class="range-calender d-contents"
                      [ngModelOptions]="{ standalone: true }"
                      [maxDateCount]="1"
                      selectionMode="single"
                      [showIcon]="true"
                      dateFormat="dd/mm/yy"
                      [firstDayOfWeek]="1"
                      placeholder="Date Ranges"
                      (onClearClick)="fields.rightoperator = null"
                      (onSelect)="changeDateFormat(fields)">
                    </p-calendar>
                  </div>
                  <div class="col-md-4 d-flex flex-column date-range date-bordered" *ngIf="fields?.format == 'format8'">
                    <p-calendar
                      hourFormat="12"
                      [(ngModel)]="fields.rightoperator"
                      inputId="basic3"
                      [timeOnly]="true"
                      placeholder="HH-MM"
                      (onSelect)="changeTime(fields)"></p-calendar>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div class="row o_ bdr" *ngIf="con_id === '203'">
          <div class="col-md-12 form-group mb-2">
            <label>Title*</label>
            <input type="text" placeholder="Subject" inputId="title" name="title" class="trigger-Name" [(ngModel)]="flow_data.task.title" />
          </div>
          <div class="col-md-12 form-group mb-2 bdr">
            <label>Job Type*</label>
            <ng-select
              [items]="jobTypes"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select Job Type"
              (change)="jobtypeHandler($event)"
              [(ngModel)]="flow_data.task.job_type.type">
            </ng-select>
          </div>
          <div class="col-md-12 form-group mb-2 bdr">
            <label>Due Date in Days*</label>
            <input
              type="number"
              placeholder=""
              min="0"
              max="365"
              inputId="due_date"
              name="due_date"
              [(ngModel)]="flow_data.task.task_calander.due_date"
              class="trigger-Name" />
          </div>
          <div class="col-md-12 form-group mb-2 bdr" *ngIf="showLeads">
            <label>Lead</label>
            <ng-select
              [items]="leads"
              bindLabel="full_name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select Lead"
              [(ngModel)]="flow_data.task.job_type.lead">
            </ng-select>
          </div>
          <div class="col-md-12 form-group mb-2 bdr">
            <label>Task Status*</label>
            <ng-select
              [items]="taskStatuses"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select Status"
              [(ngModel)]="flow_data.task.task_status">
            </ng-select>
          </div>
          <div class="col-md-12 bdr">
            <div class="form-group">
              <div class="form-check form-check-inline">
                <label class="custom-checkbox custom-checkbox-new mr-2"
                  >Recurring Task
                  <input
                    type="checkbox"
                    value="yes"
                    (change)="flow_data.task.task_calander.recurring_type = flow_data.task.task_calander.recurring_end_date = null"
                    [(ngModel)]="flow_data.task.task_calander.recurring_task" />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="custom-checkbox custom-checkbox-new"
                  tooltipPosition="top"
                  pTooltip="Create task on attached calendars of selected staff"
                  >Sync Calendar
                  <input type="checkbox" value="yes" [(ngModel)]="flow_data.task.task_calander.sync_calender" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <ng-container *ngIf="flow_data.task.task_calander.recurring_task">
            <div class="col-md-12 form-group mb-2 bdr">
              <label>Select Recurring Type</label>
              <ng-select
                [items]="[{ name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }]"
                bindLabel="name"
                bindValue="name"
                [searchable]="true"
                placeholder="Select Recurring Type"
                [(ngModel)]="flow_data.task.task_calander.recurring_type">
              </ng-select>
            </div>
            <div class="col-md-12 form-group bdr" *ngIf="flow_data.task.task_calander.recurring_type">
              <div class="form-group m-0">
                <label for="duedate">End Date in Days</label>
                <div class="w-100 right-aligned">
                  <input
                    type="number"
                    placeholder=""
                    min="0"
                    max="365"
                    inputId="recurring_end_date"
                    name="recurring_end_date"
                    [(ngModel)]="flow_data.task.task_calander.recurring_end_date"
                    class="trigger-Name" />
                </div>
              </div>
            </div>
          </ng-container>
          <div class="col-md-12 form-group mb-2 bdr">
            <label>Staff* </label>
            <re-multiSelect
              [options]="originalAssigns"
              [(selectedOptions)]="flow_data.task.staff"
              optionLabel="full_name"
              optionValue="_id"
              placeholder="Select assignee">
            </re-multiSelect>
          </div>
          <div class="col-md-12 form-group mb-2 bdr">
            <label>Team </label>
            <re-multiSelect
              [options]="originalAssignTeams"
              [(selectedOptions)]="flow_data.task.team"
              optionLabel="name"
              optionValue="_id"
              placeholder="Select Team">
            </re-multiSelect>
          </div>
          <div class="col-lg-12 form-group mb-2">
            <label class="mb-2"
              >Priority* <br />
              <small>Assign a priority for your task.</small>
            </label>
            <br />
            <div class="df" *ngIf="flow_data?.task?.prioritylist">
              <div *ngFor="let priority of flow_data?.task?.prioritylist" class="field-checkbox">
                <p-radioButton [inputId]="priority._id" name="priority" [value]="priority._id" [(ngModel)]="flow_data.task.priority"></p-radioButton>
                <label [for]="priority.key">&nbsp;{{ priority.name }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 form-group mb-2">
            <label class="mb-2"> Additional Comments </label>
            <textarea
              placeholder="Additional Comments"
              inputId="tigger_des"
              name="tigger_des"
              class="text-area-style mb-1"
              [(ngModel)]="flow_data.task.comments"></textarea>
          </div>
          <div class="form-group flex_end col-lg-12">
            <input type="file" #logoInput (change)="onLogoSelect($event)" [hidden]="1" accept=".svg,image/*" multiple="true" />
            <button type="button" class="btn btn-dark" (click)="logoInput.click()"><i class="pi pi-plus mr-2"></i> Add Files</button>
          </div>
          <div class="fonts-list">
            <div class="s-font mb-2 mr-1 position-relative" *ngFor="let logo of flow_data.task.files; let i = index">
              <i class="pi pi-times" (click)="flow_data.task.files.splice(i, 1); logoUrl.splice(i, 1)"></i>
              <img [src]="logo" alt="" class="img-fluid" />
            </div>
          </div>
          <div class="form-group col-lg-12">
            <label>Checklist</label>
            <div class="row mt-2 mx-0">
              <div class="col pl-0">
                <input
                  type="text"
                  [(ngModel)]="newItem"
                  class="site-input"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Add item in checklist" />
              </div>
              <div class="">
                <button class="btn btn-outline-primary px-4" [disabled]="newItem === ''" (click)="addCheckListItem()">
                  {{ checkItemToEdit !== null ? 'Edit' : 'Add' }}
                </button>
              </div>
            </div>
            <ul class="col-12 mb-2 checklist-list" cdkDropList (cdkDropListDropped)="drop($event)">
              <li *ngFor="let item of flow_data.task.check_list; let i = index" cdkDrag>
                <label class="custom-checkbox custom-checkbox-new">
                  <input type="checkbox" (click)="checkItemToEdit = i; newItem = item" name="checklist" />
                  <span class="checkmark rounded-circle"></span>
                  {{ item }}
                </label>
                <div class="checklist-actions position-relative d-flex">
                  <span class="x-icon icon-drag"></span>
                  <span class="close-icon sm" (click)="flow_data.task.check_list.splice(i, 1); checkItemToEdit = null"></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="form-group mb-3 bdr" *ngIf="con_id === '206'">
          <label>Select field</label>
          <ng-select
            [items]="entityField"
            bindLabel="label"
            bindValue="name"
            [searchable]="true"
            placeholder="Select Field"
            [multiple]="true"
            [(ngModel)]="flow_data.clear_ids"
            class="ng-site-input w-76 mb-1 trigger-Name min-height-select"
            name="user_id">
          </ng-select>
        </div>
      </ng-container>

      <!-- Trigger -->
      <ng-container *ngIf="con_id === '1'">
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            [disabled]="flow_data.is_submodule"
            placeholder="e.g. New Lead"
            inputId="tigger_title"
            name="tigger_title"
            [(ngModel)]="flow_data.tigger_title"
            class="trigger-Name f-12"
            (input)="bindValue()" />
        </div>
        <div class="form-group bdr">
          <label>Module</label>
          <ng-select
            [items]="module_array_extended"
            [disabled]="flow_data.is_submodule"
            bindLabel="name"
            bindValue="module_value"
            [searchable]="true"
            [(ngModel)]="flow_data.module"
            placeholder="Select Module"
            [clearable]="false"
            class="archive-field"
            name="triger_module"
            id="triger_module"
            (change)="onChangeModule($event); flow_data.readonlyfilter = null">
            <ng-template ng-option-tmp let-item="item">
              <div>
                <span>{{ item.name }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <ng-container *ngIf="!flow_data.is_child_trigger">
          <div class="form-group bdr" *ngIf="ProjectsUnits?.allunits?.length > 0">
            <re-multiSelect
              [options]="ProjectsUnits?.allunits"
              [(selectedOptions)]="ProjectsUnits.selected"
              optionLabel="name"
              optionValue="_id"
              placeholder="Select Lot"
              (onUpdate)="onChangeModule({ name: 'Specified Project Units' }, $event)">
            </re-multiSelect>
            <span *ngIf="projectunit?.invalid && (projectunit?.dirty || projectunit?.touched)" class="requireded">
              <span *ngIf="projectunit?.errors?.required"> Module is required </span>
            </span>
          </div>
          <div class="form-group bdr" *ngIf="SpecificModuleListing?.length > 0">
            <re-multiSelect
              [options]="SpecificModuleListing"
              [(selectedOptions)]="flow_data.readonlyfilter"
              optionLabel="name"
              optionValue="_id"
              placeholder="Select {{
                flow_data.module && ProjectsUnits?.allunits?.length == 0 ? _workflowService.GetAlteredModuleName(flow_data.module) : 'units'
              }}"
              (onUpdate)="onChangeUnit()">
            </re-multiSelect>
          </div>
          <div class="form-group bdr" *ngIf="excludeModuleListing?.length > 0">
            <re-multiSelect
              [options]="excludeModuleListing"
              [(selectedOptions)]="flow_data.exclude_records"
              optionLabel="name"
              optionValue="_id"
              placeholder="Select Exclusions"
              (onUpdate)="onChangeUnit()">
            </re-multiSelect>
          </div>
        </ng-container>
        <div class="form-group">
          <label>Description</label>
          <textarea
            placeholder="e.g. When a New Lead is assigned"
            inputId="tigger_des"
            name="tigger_des"
            [(ngModel)]="flow_data.tigger_desc"
            [disabled]="flow_data.is_submodule"
            (input)="bindValue()"
            class="text-area-style"></textarea>
        </div>
        <div>
          <label>Parent / Child</label>
          <div class="SP-switch">
            <p-inputSwitch [(ngModel)]="flow_data.is_child_trigger"></p-inputSwitch>
          </div>
        </div>
        <ng-container *ngIf="!flow_data.is_child_trigger">
          <div class="mt-2 form-group" *ngIf="flow_data?.startoperationtime">
            <label class="f-14">Start when</label>
            <div *ngFor="let startwhen of _workflowService?.triggerStartList" class="p-field-checkbox">
              <p-checkbox
                name="startingpoint"
                [(ngModel)]="flow_data.startoperationtime[startwhen.slug]"
                [value]="flow_data.startoperationtime[startwhen.slug]"
                [inputId]="'main' + startwhen.id"
                binary="true"
                [disabled]="flow_data.is_submodule">
              </p-checkbox>
              <label class="cursor-pointer" [for]="'main' + startwhen.id">{{ startwhen?.name }}</label>
            </div>
          </div>
          <div class="form-group">
            <label class="">Stop / Start</label>
            <div>
              <p-inputSwitch
                [disabled]="flow_data.is_submodule"
                (onChange)="onChangeTriggerCanStart($event)"
                [(ngModel)]="flow_data.canStart"></p-inputSwitch>
            </div>
          </div>
        </ng-container>
        <div class="form-group mb-3 mt-2">
          <div class="d-flex align-items-center justify-content-between">
            <button (click)="showIcon = !showIcon" class="show-icon p-0" title="Select Icon">Icon Selected</button>
            <div *ngIf="display_icon" class="d-flex align-items-center">
              <i *ngIf="isSvg == false" class="{{ display_icon }} show-display-icon ml-3"></i>
              <img *ngIf="isSvg" class="show-display-icon ml-3 arr_icon_viewable" [src]="display_icon" />
            </div>
          </div>
          <div *ngIf="showIcon && !flow_data?.is_submodule" class="mt-3 flexo_">
            <ng-container *ngFor="let item of icon_list">
              <i class="{{ item.icon }} arr_icon" (click)="changeIconHandler(item.icon)"></i>
            </ng-container>
          </div>
        </div>

        <div class="form-group">
          <label for="created_date" *ngIf="flow_data?.created_at" class="trigger-label f-12 d-block"
            >Created
            <span class="font-weight-normal">{{ flow_data?.created_at | date: 'd MMMM y' }}</span>
          </label>
          <label for="created_date" *ngIf="flow_data?.updated_at" class="trigger-label f-12 d-block"
            >Modified
            <span class="font-weight-normal">{{ flow_data?.updated_at | date: 'd MMMM y' }}</span>
          </label>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #commonConditionSaveLoad>
  <div class="d-flex flex-nowrap align-items-center justify-content-between w-100">
    <div class="flex-grow-0 mr-2">
      <button
        pButton
        pRipple
        type="button"
        *ngIf="!inputfieldConditionType.isLoadSelected"
        icon="pi pi-cloud-download"
        pTooltip="Load Condition"
        tooltipPosition="top"
        class="p-button-rounded p-button-text p-button-plain"
        (click)="inputfieldConditionType.isLoadSelected = true"></button>
      <button
        *ngIf="inputfieldConditionType.isLoadSelected"
        pButton
        pRipple
        type="button"
        icon="pi pi-plus"
        pTooltip="Create New"
        tooltipPosition="top"
        class="p-button-rounded p-button-text p-button-plain"
        (click)="inputfieldConditionType.isLoadSelected = false; inputfieldConditionType.title_resolver = ''"></button>
      <!-- <p-toggleButton [onLabel]="'Load view'" [offLabel]="'Save as'"
                [(ngModel)]="inputfieldConditionType.isLoadSelected" (onChange)="clearTitleResolver()"></p-toggleButton> -->
    </div>
    <div class="flex-grow-1 mr-2">
      <ng-container *ngIf="inputfieldConditionType.isLoadSelected; else saveInputLevel">
        <ng-select
          [items]="inputfieldConditionType.SavedConditions"
          bindLabel="title"
          [clearable]="false"
          bindValue="_id"
          [(ngModel)]="inputfieldConditionType.title_resolver"
          placeholder="Select saved conditions"
          [multiple]="false"
          class="ng-site-input w-100 mb-1 trigger-Name"
          [style.min-width.px]="100"
          name="condition_id"
          id="condition_id">
        </ng-select>
      </ng-container>
      <ng-template #saveInputLevel>
        <input
          type="text"
          placeholder="Save condition name"
          inputId="inputfield_condition"
          name="inputfield_condition"
          [(ngModel)]="inputfieldConditionType.title_resolver"
          class="trigger-Name w-100" />
      </ng-template>
    </div>
    <div class="flex-grow-0 mr-2">
      <button
        pButton
        pRipple
        type="button"
        icon="pi {{ inputfieldConditionType.isLoadSelected ? 'pi-cloud-download' : 'pi-save' }}"
        class="p-button-rounded p-button-text p-button-plain"
        (click)="SaveorLoadInputfieldCondition(condition_input?.[0])"></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-trash"
        *ngIf="inputfieldConditionType.isLoadSelected"
        class="p-button-rounded p-button-text p-button-danger mr-2"
        (click)="RemoveInputfieldCondition()"></button>
    </div>
  </div>
</ng-template>
<p-menu #menu [popup]="true" class="trigger" [model]="flow_actions"></p-menu>
<ng-template #recursiveInputField let-conditions>
  <li *ngFor="let condition of conditions; let counter = index" class="d-flex">
    <ng-container *ngIf="condition?.iscondition; else entryLevel">
      <div
        class="{{ condition?.parent == -1 ? 'd-flex' : 'd-inline-flex' }} gates-condition
                align-items-center justify-content-between bg-light rounded position-relative">
        <div class="d-inline-flex align-items-center">
          <div class="treeview__level mr-2">
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-chevron-down"
              class="p-button-rounded p-button-text p-button-plain"
              (click)="menu.toggle($event); selected_condition = condition"></button>
          </div>
          <ng-container>
            <span
              class="cursor-pointer mr-2"
              [pTooltip]="'Convert to ' + condition.condition_id == 1 ? 'OR' : 'AND'"
              (click)="condition.condition_id == 1 ? (condition.condition_id = 2) : (condition.condition_id = 1)"
              >{{ condition.condition_id == 1 ? 'AND' : 'OR&nbsp;&nbsp;&nbsp;' }}</span
            >
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #entryLevel>
      <div class="rounded w-100 position-relative {{ condition?.iscondition ? 'allow-condition' : 'not-condition d-flex' }}">
        <div class="d-flex align-items-center w-100">
          <div class="treeview__level">
            <button class="_view-btn f-12 h-auto p-2 bg-none" (click)="menu.toggle($event); selected_condition = condition">
              <i class="pi pi-chevron-down f-14"></i>
            </button>
          </div>
          <div class="row m-2 w-100 d-flex align-items-center position-relative">
            <i class="pi pi-times cross-icon" (click)="AddNewItemSameLevel(condition, false); AssignInputFieldValues()"></i>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.is_cross">
              <ng-select
                [items]="_workflowService?.module_array"
                bindLabel="name"
                bindValue="module_value"
                [searchable]="true"
                [(ngModel)]="condition.cross_module"
                placeholder="Select Module"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="module"
                id="module">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="!condition?.is_cross">
              <ng-select
                [items]="entityField"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'contacts'">
              <ng-select
                [items]="contact_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'contract'">
              <ng-select
                [items]="contract_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'lead_management'">
              <ng-select
                [items]="lead_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'properties'">
              <ng-select
                [items]="property_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'projects'">
              <ng-select
                [items]="project_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'project_units'">
              <ng-select
                [items]="project_unit_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'properties_data'">
              <ng-select
                [items]="property_data_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'tasks'">
              <ng-select
                [items]="task_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'EOI'">
              <ng-select
                [items]="EOI_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.cross_module == 'ofi'">
              <ng-select
                [items]="OFI_fields"
                bindLabel="label"
                bindValue="name"
                [searchable]="true"
                [(ngModel)]="condition.leftoperator"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="user_id"
                (change)="changeSave($event, condition)"
                id="user_id">
              </ng-select>
            </div>

            <div class="pl-0 col-md-4 bdr">
              <ng-select
                [items]="_workflowService?.boolean_array"
                bindLabel="con_name"
                bindValue="con_value"
                [searchable]="true"
                [(ngModel)]="condition.equality"
                placeholder="Select Field"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="equality"
                id="equality">
              </ng-select>
            </div>

            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.format == 'format3'">
              <ng-select
                [items]="[
                  { id: true, name: 'Yes' },
                  { id: false, name: 'No' },
                ]"
                bindLabel="name"
                [searchable]="true"
                bindValue="id"
                [(ngModel)]="condition.rightoperator"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="rightoperator"
                id="rightoperator">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.format == 'format502'">
              <ng-select
                [items]="condition?.statusArray"
                bindLabel="name"
                [searchable]="true"
                [bindValue]="condition.bindfield"
                [(ngModel)]="condition.rightoperator"
                placeholder=""
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="rightoperator"
                id="rightoperator">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4 bdr" *ngIf="condition?.format == 'format5or6'">
              <ng-select
                [items]="condition?.statusArray"
                bindLabel="name"
                [searchable]="true"
                [bindValue]="condition.bindfield"
                [(ngModel)]="condition.rightoperator"
                placeholder=""
                (change)="getAgentName($event, condition)"
                [multiple]="false"
                class="ng-site-input w-76 mb-1 trigger-Name"
                name="rightoperator"
                id="rightoperator">
              </ng-select>
            </div>
            <div class="pl-0 col-md-4" *ngIf="condition?.format == 'format1' || condition?.format == 'format4'">
              <input
                type="text"
                *ngIf="!condition?.isAddressBar"
                placeholder=""
                inputId="status_name"
                name="status_name"
                [(ngModel)]="condition.rightoperator"
                class="trigger-Name" />
              <textarea
                type="text"
                *ngIf="condition?.isAddressBar"
                placeholder="Search address"
                [(ngModel)]="condition.rightoperator"
                inputId="status_name"
                name="status_name"
                (onAddressChange)="handleAddressChange($event)"
                google-places-autocomplete
                [options]="options"
                class="text-area-style">
              </textarea>
            </div>
            <div class="pl-0 col-md-4" *ngIf="condition?.format == 'format2'">
              <input
                type="number"
                placeholder=""
                inputId="rightoperator"
                name="rightoperator"
                [(ngModel)]="condition.rightoperator"
                class="trigger-Name" />
            </div>
            <div class="pl-0 col-md-4 d-flex flex-column date-range date-bordered" *ngIf="condition?.format == 'format7'">
              <p-calendar
                [showButtonBar]="true"
                [(ngModel)]="condition.rightoperator"
                class="range-calender"
                [ngModelOptions]="{ standalone: true }"
                [maxDateCount]="1"
                selectionMode="single"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [firstDayOfWeek]="1"
                placeholder="Date Ranges"
                (onClearClick)="clearSearch()"
                (onSelect)="changeDateFormat(condition)">
              </p-calendar>
            </div>
            <div class="pl-0 col-md-4 d-flex flex-column date-range date-bordered" *ngIf="condition?.format == 'format8'">
              <p-calendar
                hourFormat="12"
                [(ngModel)]="condition.rightoperator"
                inputId="basic3"
                [timeOnly]="true"
                placeholder="HH-MM"
                (onSelect)="changeTime(condition)"></p-calendar>
            </div>
          </div>
          <p class="sample status-progress" *ngIf="condition && condition.is_condition_true">
            <img [src]="common_images?.progress_completed_icon" />
          </p>
          <p class="sample status-progress" *ngIf="condition && condition.is_condition_true === false">
            <img [src]="images?.progress_uncompleted_icon" />
          </p>
        </div>
      </div>
    </ng-template>
    <ul class="w-100" *ngIf="condition?.children">
      <ng-container *ngTemplateOutlet="recursiveInputField; context: { $implicit: condition?.children }"></ng-container>
    </ul>
  </li>
</ng-template>

<app-workflow-processes
  [class.open-processes]="toggleProcessPane"
  [active_module]="flowStackCall[0]"
  [processpane]="toggleProcessPaneObservable.asObservable()"
  (CloseProcessPane)="CloseProcessPane($event)"
  (updateFilterProcess)="updateFilterProcess($event)">
</app-workflow-processes>
